
export const REQUEST_DIALOG_STEP_TYPES = Object.freeze({
  CLIENTE: 'CLIENTE',
  SERVICIO: 'PERITAJE',
})

export const INITIAL_STEP_ORDER_VALUE = 0;